import React, { memo } from "react";
import { Route, Switch } from "react-router-dom";

import Box from "@material-ui/core/Box";

import Interaction from "./Interaction";
import Journeys from "./Journeys";
import Version from "./shared/Version";
import { CreateJourney, EditJourney } from "./Journey/index";
import Settings from "./Settings/index";
import UserMetadata from "./UserMetadata";
import ScrollToTop from "./shared/ScrollToTop";
import Material from "./Material";
import Survey from "./Journey/Surveys/Survey";
import AdminRoute from "./shared/AdminRoute";
import ConfigurationPage from "./Settings/ConfigurationPage";
import UserPage from "./Settings/UserPage";
import CompanyPage from "./Settings/CompanyPage";
import ImageExport from "./ImageExport";
import Welfares from "./Welfares";
import Copilot from "./Copilot/index";
import Prompt from "./Copilot/Prompt";
import Tags from "./Copilot/Tags";
import Tools from "./Copilot/Tools";
import NewsRouter from "./News/index";
import ImageGalleries from "./Gallery/ImageGalleries";
import ImageGalleryStart from "./Gallery/ImageGalleryStart";
import ImageGalleryEditor from "./Gallery/ImageGalleryEditor";
import Simulation from "./Simulation";

import AdaptiveCardPreview from "./AdaptiveCardPreview";
import UsersListsPage from "./UsersLists";
// import WelfareContainer from "./Welfares/Welfare";

const MainApp = () => {
  return (
    <>
      <Box
        className="scrollarea"
        display="flex"
        height="calc(100% - 37px)"
        mt={
          window.location.pathname === "/welfares"
            ? 13
            : /^\/welfares\/[^/]+$/.test(window.location.pathname)
            ? 13
            : window.location.pathname.startsWith("/welfares/")
            ? 6
            : window.location.pathname.includes("journeys") &&
              !window.location.pathname.includes("primes") &&
              !window.location.pathname.includes("nudges") &&
              !window.location.pathname.match(/surveys\/.+/) &&
              !window.location.pathname.match(/learning-materials\/.+/)
            ? 13
            : 6
        }
        overflow="auto"
      >
        <Switch>
          <Route
            exact
            component={Interaction}
            path="/journeys/:journeyId/:locale/:interactionType(primes|nudges)/:semanticId"
          />
          <Route
            exact
            component={Material}
            path="/journeys/:journeyId/:locale/learning-materials/:id"
          />
          <Route
            exact
            component={Survey}
            path="/journeys/:journeyId/:locale/surveys/:id/:tab?"
          />
          <Route
            exact
            component={AdaptiveCardPreview}
            path="/adaptivecardpreview/:semanticId/:deviceId"
          />
          <Route
            exact
            component={(props) => {
              return props.location.state?.isNew ? (
                <CreateJourney {...props} />
              ) : (
                <EditJourney {...props} />
              );
            }}
            path="/journeys/:journeyId/:locale/:tab?"
          />
          <Route
            exact
            component={Settings}
            path="/settings/:tab(integrations)/:type?"
          />
          <AdminRoute exact component={Settings} path="/settings/:tab?" />
          <Route exact component={UserMetadata} path="/user-metadata" />
          <Route exact component={Simulation} path="/simulation" />
          <Route exact component={ImageGalleries} path="/image-galleries" />
          <Route
            exact
            component={ImageGalleryStart}
            path="/image-galleries/new/start"
          />
          <Route
            exact
            component={ImageGalleryEditor}
            path="/image-galleries/:id"
          />
          <AdminRoute
            exact
            component={ConfigurationPage}
            path="/settings/cid-configurations/:cid"
          />
          <AdminRoute
            exact
            component={CompanyPage}
            path="/settings/companyuser-configuration/company/:id"
          />
          <AdminRoute
            exact
            component={UserPage}
            path="/settings/companyuser-configuration/user/:id"
          />
          <Route component={UsersListsPage} path="/userslists/:tab?" />
          <Route component={Welfares} path="/welfares/:tab?" />
          <AdminRoute exact component={Copilot} path="/copilot/:tab?" />
          <AdminRoute exact component={Prompt} path="/copilot/prompt/:id" />
          <AdminRoute
            exact
            component={Prompt}
            path="/copilot/user-prompts/:id"
          />
          <AdminRoute exact component={Tags} path="/copilot/tags/:id" />
          <AdminRoute exact component={Tools} path="/copilot/tools/:id" />

          <Route exact component={Copilot} path="/knowledge-hub/:tab?" />
          <Route exact component={Prompt} path="/knowledge-hub/prompt/:id" />
          <Route exact component={Tags} path="/knowledge-hub/tags/:id" />
          <Route exact component={Tools} path="/knowledge-hub/tools/:id" />

          <Route exact component={Copilot} path="/allitude/:tab?" />
          <Route exact component={Prompt} path="/allitude/prompt/:id" />
          <Route exact component={Tags} path="/allitude/tags/:id" />
          <Route exact component={Tools} path="/allitude/tools/:id" />

          <Route exact component={Copilot} path="/aiskilling/:tab?" />
          <Route exact component={Prompt} path="/aiskilling/prompt/:id" />
          <Route exact component={Tags} path="/aiskilling/tags/:id" />
          <Route exact component={Tools} path="/aiskilling/tools/:id" />

          <Route exact component={Copilot} path="/fincantieri/:tab?" />
          <Route exact component={Prompt} path="/fincantieri/prompt/:id" />
          <Route exact component={Tags} path="/fincantieri/tags/:id" />
          <Route exact component={Copilot} path="/cyber-tips-cdp/:tab?" />
          <Route exact component={Prompt} path="/cyber-tips-cdp/prompt/:id" />
          <Route exact component={Tags} path="/cyber-tips-cdp/tags/:id" />

          <Route component={NewsRouter} path="/news/:tab?" />
          <AdminRoute exact component={ImageExport} path="/export" />
          <Route component={Journeys} path="/" />
        </Switch>
      </Box>
      <Version />
      <ScrollToTop />
    </>
  );
};

export default memo(MainApp);
